import { render } from "./AboutView.vue?vue&type=template&id=b5bad0ca&scoped=true"
const script = {}

import "./AboutView.vue?vue&type=style&index=0&id=b5bad0ca&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5bad0ca"]])

export default __exports__